module.exports = __webpack_public_path__ + "static/media/24.6fd47445.jpg";